import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState, getTransportIdByName } from '../types';
import { TransportsState } from './types';

export const actions: ActionTree<TransportsState, RootState> ={
  getTransports: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/transports', params: data})
        .then(resp => {
          commit('setTransports', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getTransportProtocols: ({commit, dispatch},transport:number) => {
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/transports/${transport}/protocols`})
        .then(resp => {
          commit('setTransportProtocols', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getProtocolParameters: ({commit, dispatch},transportObject:any) => {
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/transports/${transportObject.transport}/protocols/${transportObject.protocol}/parameters`})
        .then(resp => {
          commit('setProtocolParameters', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTransportsMultichannel: ({commit, dispatch},data:any) => {
    const transportId = getTransportIdByName.get(data.transport);
    return new Promise((resolve, reject) => {
      axios({
        url: `/acapi/transports/${transportId}/multichannel`,
        params: { partner_id: data?.partner_id },
      })
          .then((resp) => {
            commit("setTransportsMultichannel", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
    })
  },
};
